// Solo puede estar descomentada una configuración a la vez.

/*  Conexión a los servicios del servidor de DESARROLLO.
    Descomentar cuando se vaya a trabajar en local (ionic serve) o para hacer la build de desarrollo (ionic build + npx cap sync). */


/*  Conexión a los servicios del servidor de TEST.
    Descomentar cuando se vaya a trabajar en local (ionic serve) o para hacer la build de desarrollo (ionic build + npx cap sync). */
/*export let Config = {
    url : 'https://testbackbenasque.pariver.com/api/v1/app',
    reg : 'https://testbackbenasque.pariver.com/api/v1/regNew',
    sendData: 'https://testbackbenasque.pariver.com/api/v1/sendData',
    url_get: 'https://testbackbenasque.pariver.com/api/v1/',
    url_archivos: 'https://testbackbenasque.pariver.com/',
    // Entorno TEST: el dispositivo físico no está conectado -> se simula al pulsar los botones.
    simulateDevice: true
};*/

/*  Conexión a los servicios del servidor de PRODUCCIÓN.
    Descomentar cuando se vaya a hacer la build de producción (ionic build + npx cap sync). */
export let Config = {
    url : 'https://backbenasque.pariver.com/api/v1/app',
    reg : 'https://backbenasque.pariver.com/api/v1/regNew',
    sendData: 'https://backbenasque.pariver.com/api/v1/sendData',
    url_get: 'https://backbenasque.pariver.com/api/v1/',
    url_archivos: 'https://backbenasque.pariver.com/',
    // Entorno PRODUCCIÓN: dispositivo conectado -> NUNCA simular.
    simulateDevice: false
};

export let Data = {
    email : '0',
    code : '0'
};

// Número de propietario de la app.
export let propietario = 2;